import React, { useEffect, memo } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab, LAYOUT } from 'transfix-ui'
import { FILTERS } from 'constants/notes'
import { Note, notePropType } from './Note'

export const NotesList = memo(
  ({ filter, getNotes, noteableId, noteableType, notes, ready, setFilter, submitCallback }) => {
    const handleCallback = note => {
      const { callBackAt } = note
      submitCallback({
        calledBackAt: true,
        needsCallback: callBackAt,
        ...note,
      })
    }

    /**
     * @description Fetch initial list of notes.
     */
    useEffect(() => {
      if (noteableType && noteableId && ready) {
        getNotes(noteableId, noteableType, filter)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, noteableId, noteableType])

    return (
      <Tabs value={filter} onChange={setFilter} layout={LAYOUT.fixed}>
        {FILTERS.map(({ label, value }) => (
          <Tab label={label} value={value} key={value}>
            <div className='notes-list'>
              {!notes.length ? (
                <p>No Notes</p>
              ) : (
                notes.map((note, i) => (
                  <Note
                    key={note.id}
                    note={note}
                    last={i === notes.length - 1}
                    callback={note.calledBackAt}
                    handleCallback={() => handleCallback(note)}
                  />
                ))
              )}
            </div>
          </Tab>
        ))}
      </Tabs>
    )
  }
)

NotesList.propTypes = {
  notes: PropTypes.arrayOf(notePropType).isRequired,
  submitCallback: PropTypes.func,
  noteableId: PropTypes.number,
  noteableType: PropTypes.string,
  ready: PropTypes.bool,
  getNotes: PropTypes.func,
  filter: PropTypes.string,
  setFilter: PropTypes.func,
}

NotesList.defaultProps = {
  noteableId: null,
  noteableType: null,
  ready: false,
  getNotes: () => {},
  submitCallback: () => {},
  filter: '',
  setFilter: () => {},
}
